module.exports = __webpack_public_path__ + "4dd7582a946242db2aff03b3204fc4d5.png";